import React from 'react';
import PropTypes from 'prop-types';
import css from '../ProfileHeaderMX.scss';
import withConfig from 'HOCs/withConfig/withConfig';
import { convertToAbsoluteImageURI } from 'Helpers/images';
import ShareProfile from 'Components/Profile/ShareProfile/ShareProfile';
import ReportUser from 'Components/Profile/ReportUser/ReportUser';
import ReportUserMX from 'Components/Profile/ReportUser/ReportUserMX';
import { SVG_EXT, X } from 'Constants/images';
import classNames from 'classnames';
import MemberSince from 'Components/MemberSince/MemberSince';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { FormattedMessage as Translation } from 'react-intl';
import VerifiedAccounts from '../../VerifiedAccounts/VerifiedAccounts.mobile';
import FollowButton from 'Components/Profile/FollowButton/FollowButton';
import { isCocoFofoUser } from 'Helpers/item';
import EllipsisToolTip from 'Components/EllipsisToolTip/EllipsisToolTip';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import ImageGallery from 'Components/ImageGallery/ImageGallery';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { IS_DESKTOP } from 'Constants/device.APP_TARGET';
import { checkIfPremiumUser, checkIfSuperUser, checkUserMembership } from 'Helpers/premiumUser';
import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';

const renderFollowBtn = user => (<FollowButton userName={ user?.name } userId={ user?.id } isIconFlavour={ false } size={ IS_DESKTOP ? 'normal' : 'xsmall' } />);

export const UserBrand = ({
    showOlxAutosLogo,
    userName,
    userImage,
    config,
    locality,
    sellerProfilePage,
    profileLink,
    onClickProfile,
    user,
    isClassified,
    isCurrentlyOpen,
    coverImages
}) => {
    const staticAsseturl = config.get('staticAssets');
    const invertedBrandLogo = config.get('invertedBrandLogo');
    const showMXDesign = false;
    const theme = config.get('theme', 'id');
    const cocoFofoUser = isCocoFofoUser(user);

    return (
        <div className={ classNames(css.userBrand, { [css.modernUserBrand]: isClassified },
            { [css.isSuperDealer]: checkIfSuperUser(user?.subscription_info?.type) },
            { [css.isPremium]: checkIfPremiumUser(user?.subscription_info?.type) }) }>
            <div className={ css.carousel }>
                {coverImages?.length > 0 && <ImageGallery
                    showDots={ true }
                    showFavouriteButton
                    imageSize="375"
                    imageHeight="134"
                    dotSize={ 8 }
                    showThumbsContainer={ false }
                    showIndex={ false }
                    align="right"
                    images={ coverImages }
                    dotsAlign="center"
                    stretchImage={ true }
                />}
                {userImage
                    && <div className={ css.userImage }>
                        <ImageWrapper
                            fileName={ userImage }
                            className={ classNames(css.avatarImage, coverImages?.length > 0 ? css.avatar : '') }
                        />
                    </div>
                }
            </div>
            <div className={ classNames(css.userContent, {
                [css.userContentPad]: checkUserMembership(user?.subscription_info?.type)
            }) }
            data-aut-id="userContent">
                {
                    showOlxAutosLogo
                    && <div className={ css.modernUserName }>
                        <figure className={ css.cocoLogo }>
                            <img
                                className={ invertedBrandLogo.includes('/chat') ? css.inspectedCarImage_olx : css.inspectedCarImage }
                                src={ convertToAbsoluteImageURI(invertedBrandLogo, SVG_EXT, staticAsseturl, X, '', theme) }
                                alt="inspected car"
                            />
                            {isClassified && <div className={ css.avatarInfo } >
                                <div className={ css.modernName }>
                                    {locality ? `${locality},` : ''} {userName || ''}
                                </div>
                            </div>}
                        </figure>
                    </div>
                }
                {
                    (!showOlxAutosLogo)
                    && <div className={ css.modernUserName }>
                        <div className={ css.sellerName }><EllipsisToolTip tooltip={ true } tooltipText={ userName }>{userName}</EllipsisToolTip>
                            {/* About section */}
                            {user?.about && <div className={ css.about } data-aut-id="about">
                                <div className={ css.aboutInfo }>
                                    {user.about}
                                </div>
                            </div>}
                        </div>
                        <div className={ showMXDesign ? css.shareReportSectionMX : css.shareReportSection }>
                            <div className={ css.shareBtn }>
                                <ShareProfile
                                    isLink={ !sellerProfilePage }
                                    profileLink={ profileLink }
                                    onClickProfile={ onClickProfile }
                                    userId={ user.id }
                                    textId="shareProfile"
                                    size={ IS_DESKTOP ? 'small' : 'xsmall' }
                                    showMXBtn={ true }
                                    isClassified={ isClassified }
                                    origin={ TrackerOrigins.VIEW_ITEM }
                                />
                            </div>
                            {!showMXDesign
                                && <div className={ css.reportBtn } >
                                    <ReportUser userId={ user.id } shiftReportLeft={ isClassified ? null : true } isClassified={ isClassified } />
                                </div>
                            }
                            {showMXDesign && <ReportUserMX user={ user } />
                            }
                        </div>
                    </div>
                }

                {
                    isClassified
                    && <div className={ css.midInfo }>

                        <div className={ css.verifyMemberSince }>
                            {/* verified section */}
                            <div className={ css.verifyUser }>
                                <Icon data-aut-id="tickInShield" theme={ theme } icon="tickInShield" size={ 30 } color="greenBase" overrideClassName={ css.greenIcon } />
                                <Translation id="userVerifiedWith" />
                                <div className={ css.verifyUserIcons }>
                                    <VerifiedAccounts user={ user } socialIconType={ 'profile' } />
                                </div>
                            </div>

                            {/* member since section */}
                            {!cocoFofoUser && <div className={ css.members }>
                                <div className={ css.memberSince }>
                                    <MemberSince user={ user } isClassified={ isClassified } />
                                </div>
                            </div>}
                        </div>

                        <div className={ css.buttonsWrapper }>
                            <MembershipTagV1
                                type={ user?.subscription_info?.type || '' }
                                containerClassName={ css.tagContainerClassName }
                                textClassName={ css.textClassName }
                                iconClassName={ css.iconClassName }
                            />
                            <div className={ css.followButton }>
                                {renderFollowBtn(user)}
                            </div>
                        </div>

                        {isCurrentlyOpen && <div className={ css.status }><Translation id="openNow" /></div>}
                    </div>
                }

                {!isClassified && locality && <div className={ css.locality } data-aut-id="locality">{locality}</div>}
            </div>
            <div className={ css.divider } />
        </div>
    );
};

UserBrand.propTypes = {
    showOlxAutosLogo: PropTypes.bool,
    userName: PropTypes.string,
    userImage: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    locality: PropTypes.string,
    sellerProfilePage: PropTypes.bool,
    isClassified: PropTypes.bool,
    profileLink: PropTypes.string,
    onClickProfile: PropTypes.func,
    user: PropTypes.object,
    coverImages: PropTypes.array,
    isCurrentlyOpen: PropTypes.bool
};

UserBrand.defaultProps = {
    showOlxAutosLogo: false,
    userName: '',
    userImage: '',
    locality: '',
    sellerProfilePage: true,
    isClassified: false,
    profileLink: '',
    onClickProfile: () => { },
    user: {},
    userLogged: {},
    operatingDetailsObject: {}
};

export default withConfig(React.memo(UserBrand));
